import type { App } from '../../app.js';
import { h, button } from '../dom.js';

export function buildTitleScreen(app: App): HTMLElement {
  const start = () => {
    // the key listener must die with the title screen — Space doubles as BOOST,
    // and a leaked listener here used to yank racers back to the menu mid-race
    window.removeEventListener('keydown', onKey);
    app.audio.unlock();
    app.audio.play('ui_confirm');
    if (!app.settings.firstRunDone) firstRun(app, screen);
    else app.show('menu');
  };

  const screen = h(
    'div',
    { class: 'screen' },
    h('div', { class: 'title-xl', text: 'VOIDLINE' }),
    h('div', {
      class: 'subtle',
      text: 'ANTI-GRAVITY RACING LEAGUE',
      style: 'letter-spacing:0.5em; margin-top:14px; text-indent:0.5em;',
    }),
    h(
      'div',
      { style: 'margin-top:60px;' },
      button('ENGAGE', start, 'primary focusable')
    ),
    h('div', {
      class: 'subtle',
      style: 'position:absolute; bottom:26px; font-size:11px; letter-spacing:0.2em;',
      text: 'KEYBOARD · GAMEPAD SUPPORTED — F3 FOR DIAGNOSTICS',
    })
  );

  const onKey = (e: KeyboardEvent) => {
    // self-destruct if the title screen is no longer showing (any navigation path)
    if (app.screen !== 'title') {
      window.removeEventListener('keydown', onKey);
      return;
    }
    if (e.code === 'Enter' || e.code === 'Space') start();
  };
  window.addEventListener('keydown', onKey);
  return screen;
}

/** First run: pick a callsign, offer the tutorial. */
function firstRun(app: App, parent: HTMLElement): void {
  parent.innerHTML = '';
  const input = h('input', {
    type: 'text',
    maxlength: '20',
    placeholder: 'YOUR CALLSIGN',
    value: app.settings.playerName,
    style: 'text-align:center; width: 300px;',
  }) as HTMLInputElement;

  const done = (tutorial: boolean) => {
    const name = input.value.trim().replace(/[^\w\-. ]/g, '').slice(0, 20) || 'PILOT';
    app.settings.playerName = name;
    app.settings.firstRunDone = true;
    app.saveAll();
    app.audio.play('ui_confirm');
    if (tutorial) {
      app.settings.tutorialDone = true;
      app.saveAll();
      app.startSoloRace({
        trackId: 'ionport',
        trackSeed: null,
        mode: 'timetrial',
        laps: 3,
        botCount: 0,
        botDifficulty: 'cruise',
        tutorial: true,
        useGhost: false,
      });
    } else {
      app.show('menu');
    }
  };

  parent.append(
    h('div', { class: 'h1', text: 'WELCOME, PILOT' }),
    h('div', { class: 'subtle', text: 'Choose a callsign for the league rosters.', style: 'margin:18px 0 26px;' }),
    input,
    h(
      'div',
      { class: 'row', style: 'margin-top:34px; gap:16px;' },
      button('FLIGHT SCHOOL (TUTORIAL)', () => done(true), 'primary focusable'),
      button('STRAIGHT TO THE GRID', () => done(false), 'focusable')
    )
  );
  input.focus();
}
